/* Package JSON Import will be here */
import React from "react";
import { Icon, Header, Segment, Pagination, Button, Modal, Checkbox } from "semantic-ui-react";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import { Constants } from "../../../src/config/appConstants";
import "./tmVoucher.css";
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import AttachmentViewer from "../sharedComponent/attachmentViewer/attachmentViewer.Container"
import TMVoucherTableComponent from '../sharedComponent/tmVoucherViewer/tmVoucherTable.Component'
/* Project Import will be here */

const TMVoucherComponent = (props) => {
  return (
    <Layout>
      <Segment className="header-section">
        <Header as="h3">
          <Icon>
            <span
              className="iconify"
              style={{ color: "#dededf" }}
              data-icon="heroicons:ticket"
              data-inline="false"
            ></span>
          </Icon>
          <span>T&M Voucher</span>
        </Header>
        
        <div className="align-right issue-date">
          {[Constants.SYSTEM_ADMIN_ROLE_NAME, Constants.ADMIN_ROLE_NAME].includes(props.user.roleName) && 
            <Checkbox disabled={!props.tmVoucher.lastArchiveDate} className='archiveLable' checked={props.tmVoucher.isCheckedArchive} label='Archive' onChange={(e, value) => { props.handleArchiveCheckboxChange(value.checked) }}></Checkbox>
          }
          <MuiPickersUtilsProvider utils={DateFnsUtils} >
            <KeyboardDatePicker className="issue-field"
              disabled={!props.tmVoucher.isDatePickerEnabled}
              placeholder="MM/dd/yyyy"
              value={props.tmVoucher.selectedFromDate}
              onChange={date => props.handleFromDateChange(date)}
              inputProps={{ readOnly: true }}
              format="MM/dd/yyyy"
              inputVariant="outlined"
              label="From"
              {...(props.tmVoucher.minimumDate ? { minDate :  props.tmVoucher.minimumDate} : {})} 
              {...(props.tmVoucher.maximumDate ? { maxDate : props.tmVoucher.maximumDate} : {})}
            />
          </MuiPickersUtilsProvider>
          <MuiPickersUtilsProvider utils={DateFnsUtils} >
            <KeyboardDatePicker
              disabled={!props.tmVoucher.isDatePickerEnabled}
              className="issue-field"
              placeholder="MM/dd/yyyy"
              value={props.tmVoucher.selectedToDate}
              onChange={date => props.handleToDateChange(date)}
              inputProps={{ readOnly: true }}
              format="MM/dd/yyyy"
              inputVariant="outlined"
              label="To"
              {...(props.tmVoucher.minimumDate ? { minDate :  props.tmVoucher.minimumDate} : {})} 
              {...(props.tmVoucher.maximumDate ? { maxDate : props.tmVoucher.maximumDate} : {})}
            />
          </MuiPickersUtilsProvider>
        </div>
      </Segment>
      <div className="tableVertical mt-2">
        <TMVoucherTableComponent
          tmVoucher={props.tmVoucher.voucherList}
          isShowRevisionModal={props.tmVoucher.isShowRevisionModal}
          employeeSearchText={props.tmVoucher.tMVoucherEmployeeSearchText}
          deviceNameSearchText={props.tmVoucher.tMVoucherDeviceNameSearchText}
          projectSearchText={props.tmVoucher.tMVoucherProjectSearchText}
          taskCodeSearchText={props.tmVoucher.tMVoucherTaskCodeSearchText}
          syncedDateSearchText={props.tmVoucher.tMVoucherSyncedDateSearchText}
          selectedSyncDate={props.tmVoucher.tMVoucherSelectedSyncDate}
          versionSearchText={props.tmVoucher.tMVoucherVersionSearchText}
          statusSearchText={props.tmVoucher.tMVoucherStatusSearchText}
          selectedTimecardDate={props.tmVoucher.tmVoucherSelectedTimecardDate}
          minDate={props.tmVoucher.minimumDate ? { minDate: props.tmVoucher.minimumDate } : {}}
          maxDate={props.tmVoucher.maximumDate ? { maxDate: props.tmVoucher.maximumDate } : {}}
          splitDeviceName={props.splitDeviceName.bind(this)}
          onSearchChange={props.onSearchChange.bind(this)}
          openAttachments={props.openAttachments.bind(this)}
          handleSyncDateChange={props.handleSyncDateChange.bind(this)}
          openTMReport={props.openTMReport.bind(this)}
          onClickDownload={props.onClickDownload.bind(this)}
          openRevisionModal={props.openRevisionModal.bind(this)}
          handleTimecardDateChange={props.handleTimecardDateChange.bind(this)}
          voucherNumberSearchText={props.tmVoucher.tMVoucherNumberSearchText}
          signatureOptions={props.tmVoucher.signatureOptions}
          selectedSignatureTMVoucherOptions={props.tmVoucher.selectedSignatureTMVoucherOptions}
          onChangeSignature={props.onChangeSignature.bind(this)}
          isDatePickerEnabled={props.tmVoucher.isDatePickerEnabled}
        />
      </div>
      {props.tmVoucher.voucherList &&
        props.tmVoucher.voucherList.length > 0 && (
          <Pagination
            floated="right"
            activePage={props.tmVoucher.pagination.activePage}
            onPageChange={props.paginationChange}
            ellipsisItem={null}
            firstItem={null}
            lastItem={null}
            totalPages={props.tmVoucher.pagination.totalCount}
          />
        )}

      {/* {Attachments pop up } */}
      <Modal closeIcon
        open={props.tmVoucher.isShowAttachments}
        closeOnDimmerClick={false}
        size='tiny'
        onClose={() => props.closeAttachmentsModal()} >
        <Modal.Header className="headerColor text-color">TMVoucher Attachments</Modal.Header>
        <Modal.Content scrolling style={{ minHeight: "auto" }}>
          <div>
            <h5 className="timecardAttachment">Attachments
              <a class="ui teal tiny label">{props.tmVoucher.selectedTMVoucherAttachments.attachments && props.tmVoucher.selectedTMVoucherAttachments.attachments.length}</a>
            </h5>
            {props.tmVoucher.selectedTMVoucherAttachments.attachments && props.tmVoucher.selectedTMVoucherAttachments.attachments.length > 0 && props.tmVoucher.selectedTMVoucherAttachments.attachments.map(attach => {
              return (<img style={{ width: '50px', height: '50px', marginLeft: '5px' }} alt={attach.attachmentName} src={Constants.DATA_BASE64 + attach.attachmentContent} onClick={() => props.openAttachmentViewer(attach)} />)
            })}
          </div>
        </Modal.Content>
        <Modal.Actions>
          {(props.tmVoucher.selectedTMVoucherAttachments.attachments && props.tmVoucher.selectedTMVoucherAttachments.attachments.length > 0) && <Button onClick={props.onClickPrint} primary>Print</Button>}
          <Button secondary onClick={() => props.closeAttachmentsModal()}>
            Back
          </Button>
        </Modal.Actions>
      </Modal>

      {/* {Pdf TM Report pop up} */}
      <Modal closeIcon
        open={props.tmVoucher.isShowTMVoucherPDF}
        closeOnDimmerClick={false}
        size='medium'
        onClose={() => props.closeTMReport()}
      >
        <Modal.Header className="headerColor text-color">TM Reports</Modal.Header>
        <Modal.Content scrolling style={{ minHeight: "auto" }}>
          {props.tmVoucher.selectedTMVoucher && props.tmVoucher.selectedTMVoucher.attachmentContent && <div>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.2.228/build/pdf.worker.min.js">
              <Viewer
                fileUrl={Constants.PDFDATA_BASE64 + props.tmVoucher.selectedTMVoucher.attachmentContent}
              />
            </Worker>
          </div>
          }
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => props.closeTMReport()}>
            Back
          </Button>
        </Modal.Actions>
      </Modal>

      {/* {Revision pop up} */}
      <Modal closeIcon
        open={props.tmVoucher.isShowRevisionModal}
        closeOnDimmerClick={false}
        size='fullscreen'
        onClose={() => props.closeRevisionModal()}
      >
        <Modal.Header className="headerColor text-color">Revision History</Modal.Header>
        <Modal.Content scrolling>
          {/* <Modal.Content scrolling> */}
          <TMVoucherTableComponent
            tmVoucher={props.tmVoucher.revisionList}
            isShowRevisionModal={props.tmVoucher.isShowRevisionModal}
            employeeSearchText={props.tmVoucher.revisionEmployeeSearchText}
            deviceNameSearchText={props.tmVoucher.revisionDeviceNameSeachText}
            projectSearchText={props.tmVoucher.revisionProjectSearchText}
            taskCodeSearchText={props.tmVoucher.revisionTaskCodeSearchText}
            syncedDateSearchText={props.tmVoucher.revisionSyncedDateSearchText}
            selectedSyncDate={props.tmVoucher.revisionSelectedSyncDate}
            versionSearchText={props.tmVoucher.revisionVersionSearchText}
            statusSearchText={props.tmVoucher.revisionStatusSearchText}
            selectedTimecardDate={props.tmVoucher.revisionSelectedTimecardDate}
            minDate={props.tmVoucher.minimumDate ? { minDate: props.tmVoucher.minimumDate } : {}}
            maxDate={props.tmVoucher.maximumDate ? { maxDate: props.tmVoucher.maximumDate } : {}}
            onSearchChange={props.onSearchChange.bind(this)}
            openAttachments={props.openAttachments.bind(this)}
            handleSyncDateChange={props.handleSyncDateChange.bind(this)}
            splitDeviceName={props.splitDeviceName.bind(this)}
            openTMReport={props.openTMReport.bind(this)}
            onClickDownload={props.onClickDownload.bind(this)}
            handleTimecardDateChange={props.handleTimecardDateChange.bind(this)}
            voucherNumberSearchText={props.tmVoucher.revisionNumberSearchText}
            signatureOptions={props.tmVoucher.signatureOptions}
            selectedSignatureTMVoucherOptions={props.tmVoucher.selectedSignatureRevisionOptions}
            onChangeSignature={props.onChangeSignature.bind(this)}
            isDatePickerEnabled={props.tmVoucher.isDatePickerEnabled}
          />
          {/* </Modal.Content> */}
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => props.closeRevisionModal()}>
            Back
          </Button>
        </Modal.Actions>
      </Modal>

      {
        props.tmVoucher.isAttachmentModelVisible &&
        <AttachmentViewer attachmentName={props.tmVoucher.selectedAttachmentContent.attachmentName} attachmentContent={props.tmVoucher.selectedAttachmentContent.attachmentContent} closeAttachmentViewer={props.closeAttachmentViewer} />
      }
    </Layout>
  );
};

export default TMVoucherComponent;

TMVoucherComponent.displayName = "TMVoucherComponent";

